import { forOwn } from 'lodash';
import { BREAKPOINTS } from '../variables/breakpoints';
import { TEXT_SIZES } from '../variables/typography';

export const setFont = props => {
  let correctFont = 'univers-roman';
  if (props.bold) {
    correctFont = 'univers-bold';
  } else if (props.serif || props.display) {
    correctFont = 'hs-deville';
  }
  if (props.headline) {
    correctFont = 'univers-black';
  }
  if (props.condensed) {
    correctFont = 'univers-bold-cond';
  }
  if (props.rounded && props.type) {
    correctFont = props.type;
  }
  return `font-family: ${correctFont};`;
};

export const setFontSizes = ({ xs, sm, md, lg, xl, xxl }) => {
  const fontSizeProps = {
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
  };
  let style = '';
  forOwn(fontSizeProps, (val, breakpoint) => {
    if (val) {
      if (breakpoint === 'xs') {
        style += `font-size: ${TEXT_SIZES[val] || val};`;
      } else {
        style += `
                @media (min-width: ${BREAKPOINTS[breakpoint]}px) {
                    font-size: ${TEXT_SIZES[val] || val};
                }
            `;
      }
    }
  });
  return style;
};
